module.exports = __webpack_public_path__ + "img/f62d85f74ac9dd6b839ed7f2aa73d914.png";